export default __webpack_public_path__ + "static/media/logo.9dad5e65.png";